import React from 'react';
import { colors } from '@/globalStyles';
import { measureText } from '../../../helpers/calculation';
import { generateFontString } from '../../../helpers/general';

const getTransform = ({ text_style, x, y, correctY }) => {
  if (text_style.angle) {
    return { transform: `rotate(${text_style.angle} ${x} ${y})` };
  } else if (text_style.transforms?.angle) {
    return { transform: `rotate(${360 - text_style.transforms.angle} ${x} ${correctY})` };
  }
  return {};
};

const TextComponent = props => {
  const { id, primitiveProps, style, svgElementClickableRef, className } = props;
  const {
    position: { x, y },
    text: value,
    text_style,
  } = primitiveProps;
  const parsedStyle = JSON.parse(JSON.stringify(style));
  const font = !parsedStyle.font && text_style ? generateFontString(text_style.bold, text_style.italic, text_style.text_height, text_style.font_name) : null;
  // in svg position of text is left-bottom corner. from params receive left-top corner.
  const textHeight = (!text_style?.text_height && font) ? measureText(value, font).height : (text_style?.text_height || 0);
  const correctY = y + textHeight;
  const styles = {
    ...parsedStyle,
    pointerEvents: className === 'decoration' ? 'none' : 'unset',
    font,
    ...(!parsedStyle.color && { fill: text_style && text_style.color ? text_style.color : colors.black }),
  };
  const transform = getTransform({ text_style, x, y, correctY });

  return (
    <text id={id} x={x} y={correctY} style={styles} className={className} ref={svgElementClickableRef} {...transform}>
      {value}
    </text>
  );
};

export default TextComponent;
